/**
 * Helper method to instantiate corresponding Change plugin based on change type
 * @module
 */
var PromiseEnv = require('core/lib/promise').Promise;

var DateEnv = require('core/env/date');
var di = require('../di');
var PluginsStore = di.get('stores/plugins');
var enums = require('../constants/enums');
var Logger = require('../utils/logger');

/**
 * Helper function to create change instances.
 * @param {Change} change
 * @param {ActionData} [action]
 * @param {number} [actionStartTime] Date when action was started
 * @returns {ChangeApplier}
 * @throws {Error} if cannot find a plugin for this change type
 */
exports.create = function(change:Change, action?:ActionData, actionStartTime?:number): ChangeApplier {
  var config = {
    identifier: change.id,
    action: action,
    startTime: actionStartTime || DateEnv.now()
  };

  if (__INVARIANT__) {
    require('core/utils/invariant').isType('Change', change);
    require('core/utils/invariant').isType('ChangeConfig', config);
  }

  try {
    var applierClass = PluginsStore.getPlugin(enums.PluginTypes.changeAppliers, change.type);
    if (!applierClass) {
      throw new Error('Unrecognized change type ' + change.type);
    }
    // Construct a new change applier instance. The constructor may throw.
    return new applierClass(change, config);
  } catch (e) {
    Logger.error('Change applier was never properly constructed:', e);
    // There was an error while constructing the applier instance,
    // but we shouldn't allow that error to blow up the entire layer's activation
    // (the closest catch statement is in decideAndExecuteLayerASAP).
    // Instead, we can pretend the constructor succeeded, returning
    // a fake applier instance whose .apply method rejects.
    // TODO(nikhil): This is a hack; refactor.
    var invalidApplierInstance:any = {
      apply: function() {
        return PromiseEnv.reject(e);
      }
    };
    if(__EDITOR__ || __TEST__) {
      invalidApplierInstance.undo = function() {
        return PromiseEnv.resolve(enums.changeState.ERROR);
      };
      invalidApplierInstance.cancel = function() {};
    }
    return invalidApplierInstance;
  }
};
